import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { TextCheckbox } from 'taboola-ultimate-ui';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { campaignInitialValues, DUPLICATE_CAMPAIGN_SETTINGS_TYPE } from '../../../config';
import { useThirdPartyTagsFormFieldValue } from '../../ThirdPartyTags/useThirdPartyTagsFormFieldValue';
import { useTrackingCodeFormField } from '../../TrackingCode/hooks/useTrackingCodeFormField';
import ThirdPartyTrackingTooltip from './ThirdPartyTrackingTooltip';
import styles from './thirdPartyTrackingSetting.module.scss';

const ThirdPartyTrackingSetting = ({ checked }) => {
    const isTrackingCodeDefaultValueEmpty = useConfigMatch({ [FEATURE_FLAGS.IS_DEFAULT_TRACKING_CODE_EMPTY]: 'true' });
    const { value: trackingCode, onChange: onChangeTrackingCode } = useTrackingCodeFormField({ field: 'trackingCode' });
    const { value: thirdPartyTags, onChange: onChangeThirdPartyTags } = useThirdPartyTagsFormFieldValue();

    const originalCampaignTrackingCode = useRef(trackingCode);
    const originalCampaignThirdPartyTags = useRef(thirdPartyTags);

    useEffect(() => {
        if (checked) {
            onChangeTrackingCode(originalCampaignTrackingCode.current);
            onChangeThirdPartyTags(originalCampaignThirdPartyTags.current);
            return;
        }

        onChangeThirdPartyTags();
        onChangeTrackingCode(campaignInitialValues.trackingCode({ isTrackingCodeDefaultValueEmpty }));
    }, [checked, isTrackingCodeDefaultValueEmpty, onChangeThirdPartyTags, onChangeTrackingCode]);

    return (
        <TextCheckbox
            helpText={<ThirdPartyTrackingTooltip />}
            value={DUPLICATE_CAMPAIGN_SETTINGS_TYPE.TRACKING_CODE_THIRD_PARTY_PIXEL}
            label="third-party-tracking-checkbox"
            title={
                <FormattedMessage
                    id="campaign.editor.duplicateCampaignSettings.TrackingCodeAndThirdPartyTags"
                    defaultMessage="Tracking Code and 3rd Party Tags"
                />
            }
            labelClassName={styles['label']}
        />
    );
};

ThirdPartyTrackingSetting.propTypes = {
    checked: PropTypes.bool,
};

export default ThirdPartyTrackingSetting;
